import { virtualQRByLocationId } from "../Constants/VirtualQrByLocation";

export const getVirtualQRByLocationId = (virtualqrByLocationId) => {
    return {
        type: virtualQRByLocationId.GET_VIRTUALQRByLocationId,
        payload: virtualqrByLocationId
    };
};
